module.exports = __webpack_public_path__ + "img/monitor_right.61e0c894.jpg";